export default __webpack_public_path__ + "static/media/house.c854a68b.png";